import { createRouter, createWebHistory } from 'vue-router';
import { pv } from '@/utils/pv';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../layout/Main.vue'),
    children: [
      {
        path: '',
        name: 'Index',
        component: () => import(/* webpackChunkName: "index" */ '../views/Index.vue'),
      },
      {
        path: '/video/detail/:id',
        name: 'VideoDetail',
        component: () => import(/* webpackChunkName: "videodetail" */ '../views/VideoDetail.vue'),
      },
      {
        path: '/ablum/:type',
        name: 'AblumList',
        component: () => import(/* webpackChunkName: "ablumlist" */ '../views/AblumList.vue'),
      },
      {
        path: '/material/:cid',
        name: 'MaterialList',
        component: () => import(/* webpackChunkName: "materiallist" */ '../views/MaterialList.vue'),
      },
      {
        path: '/ablum/detail/:id',
        name: 'AblumListDetail',
        component: () => import(/* webpackChunkName: "ablumListdetail" */ '../views/AblumListDetail.vue'),
      },
      {
        path: '/cart',
        name: 'Cart',
        meta: {
          title: '购物车',
        },
        component: () => import(/* webpackChunkName: "cart" */ '../views/Cart.vue'),
      },
      {
        path: '/buy/:from',
        name: 'ConfirmBuy',
        meta: {
          title: '订单确认',
        },
        component: () => import(/* webpackChunkName: "confirmbuy" */ '../views/ConfirmBuy.vue'),
      },
      {
        path: '/pay',
        name: 'Payment',
        meta: {
          title: '支付',
        },
        component: () => import(/* webpackChunkName: "payment" */ '../views/Payment.vue'),
      },
      {
        path: '/personalcollect/:id',
        name: 'PersonalCollect',
        meta: {
          title: '个人专辑',
        },
        component: () => import(/* webpackChunkName: "personalcollect" */ '../views/PersonalCollect.vue'),
      },
      {
        path: '/account',
        name: 'Account',
        redirect: '/account/welcome',
        meta: {
          title: '个人中心',
        },
        component: () => import(/* webpackChunkName: "accountlayout" */ '../views/AccountLayout.vue'),
        children: [
          {
            path: 'order',
            name: 'OrderList',
            meta: {
              title: '订单列表',
            },
            component: () => import(/* webpackChunkName: "orderlist" */ '../views/Account/OrderList.vue'),
          },
          {
            path: 'authrecord',
            name: 'AuthRecord',
            meta: {
              title: '授权记录',
            },
            component: () => import(/* webpackChunkName: "authrecord" */ '../views/Account/AuthRecord.vue'),
          },
          {
            path: 'myauth',
            name: 'MyAuth',
            meta: {
              title: '我的授权',
            },
            component: () => import(/* webpackChunkName: "authrecord" */ '../views/Account/AuthRecord.vue'),
          },
          {
            path: 'collect',
            name: 'MyCollect',
            meta: {
              title: '我的专辑',
            },
            component: () => import(/* webpackChunkName: "mycollect" */ '../views/Account/MyCollect.vue'),
          },
          {
            path: 'collect/detail/:id',
            name: 'MyCollectDetail',
            meta: {
              title: '专辑内容',
            },
            component: () => import(/* webpackChunkName: "mycollectdetail" */ '../views/Account/MyCollectDetail.vue'),
          },
          {
            path: 'wallet',
            name: 'MyWallet',
            meta: {
              title: '我的钱包',
            },
            component: () => import(/* webpackChunkName: "mywallet" */ '../views/Account/MyWallet.vue'),
          },
          {
            path: 'welcome',
            name: 'Welcome',
            meta: {
              title: '个人中心',
            },
            component: () => import(/* webpackChunkName: "accountwelcome" */ '../views/Account/Welcome.vue'),
          },
          {
            path: 'coupon',
            name: 'Coupon',
            meta: {
              title: '我的优惠券',
            },
            component: () => import(/* webpackChunkName: "accountcoupon" */ '../views/Account/Coupon.vue'),
          },
          {
            path: 'setting',
            name: 'Setting',
            meta: {
              title: '个人设置',
            },
            component: () => import(/* webpackChunkName: "setting" */ '../views/Account/Setting.vue'),
          },
          {
            path: 'verify/:type?',
            name: 'AccountVerify',
            meta: {
              title: '账号认证',
            },
            component: () => import(/* webpackChunkName: "accountverify" */ '../views/Creator/VerifyAccount.vue'),
          },
          {
            path: 'security',
            name: 'Security',
            meta: {
              title: '安全中心',
            },
            component: () => import(/* webpackChunkName: "security" */ '../views/Account/Security.vue'),
          },
          {
            path: 'ticket',
            name: 'Ticket',
            meta: {
              title: '开票申请',
            },
            component: () => import(/* webpackChunkName: "ticket" */ '../views/Account/Ticket.vue'),
          },
          {
            path: 'imgticket',
            name: 'ImgTicket',
            meta: {
              title: '图片专区开票申请',
            },
            component: () => import(/* webpackChunkName: "imgticket" */ '../views/Account/ImgTicket.vue'),
          },
          {
            path: 'subsidiaryList',
            name: 'SubsidiaryList',
            meta: {
              title: '子账号管理',
            },
            component: () => import(/* webpackChunkName: "ticket" */ '../views/Account/SubsidiaryList.vue'),
          },
          {
            path: 'ticket/detail',
            name: 'TicketDetail',
            meta: {
              title: '确认开票信息',
            },
            component: () => import('../views/Account/TicketDetail.vue'),
          },
          {
            path: 'popular',
            name: 'Popular',
            meta: {
              title: '我要推广',
            },
            component: () => import(/* webpackChunkName: "popular" */ '../views/Account/Popular.vue'),
          },
          {
            path: 'invited',
            name: 'PopularInvited',
            meta: {
              title: '邀请赚钱',
            },
            component: () => import(/* webpackChunkName: "PopularInvited" */ '../views/Account/PopularInvited.vue'),
          },
          {
            path: 'historyList',
            name: 'HistoryList',
            meta: {
              title: '历史浏览记录',
            },
            component: () => import(/* webpackChunkName: "popular" */ '../views/Account/HistoryList.vue'),
          },
          // {
          //   path: 'career',
          //   name: 'VerifyCareer',
          //   meta: {
          //     title: '个人身份认证',
          //   },
          //   component: () => import(/* webpackChunkName: "verifycareer" */ '../views/Creator/VerifyCareer.vue'),
          // },
          {
            path: 'purchasePackage',
            name: 'PurchasePackage',
            meta: {
              title: '已购买图片套餐',
            },
            component: () => import(/* webpackChunkName: "purchasePackage" */ '../views/Account/PurchasePackage.vue'),
          },
          {
            path: 'imageConsume',
            name: 'imageConsume',
            meta: {
              title: '套餐消费记录',
            },
            component: () => import(/* webpackChunkName: "imageConsume" */ '../views/Account/ImageConsumeList.vue'),
          },
          {
            path: 'imageDownload',
            name: 'imageDownload',
            meta: {
              title: '图片下载记录',
            },
            component: () => import(/* webpackChunkName: "imageDownload" */ '../views/Account/ImageDownloadList.vue'),
          },
        ],
      },
      {
        path: '/creator',
        name: 'Creator',
        redirect: '/creator/upload',
        meta: {
          title: '供稿人中心',
        },
        component: () => import(/* webpackChunkName: "accountlayout" */ '../views/AccountLayout.vue'),
        children: [
          {
            path: 'upload',
            name: 'CreatorOssUpload',
            meta: {
              title: '上传视频素材',
            },
            component: () => import(/* webpackChunkName: "creatoruploadoss" */ '../views/Creator/UploadBatchOss.vue'),
          },
          {
            path: 'upload/image',
            name: 'CreatorImgLocalUpload',
            meta: {
              title: '上传图片素材',
            },
            component: () => import(/* webpackChunkName: "creatoruploadimg" */ '../views/Creator/UploadBatchImage.vue'),
          },
          {
            path: 'works',
            name: 'CreatorWorks',
            meta: {
              title: '素材管理',
            },
            component: () => import(/* webpackChunkName: "creatorworks" */ '../views/Creator/AllWorks.vue'),
          },
          {
            path: 'sales',
            name: 'CreatorSales',
            meta: {
              title: '销售记录',
            },
            component: () => import(/* webpackChunkName: "creatorsales" */ '../views/Creator/Sales.vue'),
          },
          {
            path: 'withdraw',
            name: 'Withdraw',
            meta: {
              title: '提现',
            },
            component: () => import(/* webpackChunkName: "creatorwithdraw" */ '../views/Creator/Withdraw.vue'),
          },
          {
            path: 'withdraw/detail',
            name: 'WithdrawDetail',
            meta: {
              title: '确认提现信息',
            },
            component: () => import('../views/Creator/WithdrawDetail.vue'),
          },
        ],
      },
      {
        path: '/cyprotect',
        name: 'CyProtect',
        redirect: '/cyprotect/myorderinfo',
        meta: {
          title: '版权保护',
        },
        component: () => import(/* webpackChunkName: "accountlayout" */ '../views/AccountLayout.vue'),
        children: [
          {
            path: 'mydeposit',
            name: 'MyDeposit',
            meta: {
              title: '我的存证',
            },
            component: () => import(/* webpackChunkName: "mydeposit" */ '../views/CyProtect/MyDeposit.vue'),
          },
          {
            path: 'myorderinfo',
            name: 'MyOrderInfo',
            meta: {
              title: '我的订单',
            },
            component: () => import(/* webpackChunkName: "myorderinfo" */ '../views/CyProtect/MyOrderInfo.vue'),
          },
          {
            path: 'myregister',
            name: 'MyRegister',
            meta: {
              title: '我的版权局官方登记',
            },
            component: () => import(/* webpackChunkName: "myregister" */ '../views/CyProtect/MyRegister.vue'),
          },
          {
            path: 'mymonitor',
            name: 'MyMonitor',
            meta: {
              title: '我的版权监测',
            },
            component: () => import(/* webpackChunkName: "mymonitormix" */ '../views/CyProtect/MyMonitorMix.vue'),
          },
          {
            path: 'mymonitorimg',
            name: 'MyMonitorImg',
            meta: {
              title: '我的版权监测-图片',
            },
            component: () => import(/* webpackChunkName: "mymonitor" */ '../views/CyProtect/MyMonitor.vue'),
          },
          {
            path: 'mymonitorvideo',
            name: 'MyMonitorVideo',
            meta: {
              title: '我的版权监测-视频',
            },
            component: () => import(/* webpackChunkName: "mymonitorvideo" */ '../views/CyProtect/MyMonitorVideo.vue'),
          },
          {
            path: 'myjustice',
            name: 'MyJustice',
            meta: {
              title: '我的数字公证',
            },
            component: () => import(/* webpackChunkName: "mymonitor" */ '../views/CyProtect/MyJustice.vue'),
          },
          {
            path: 'mycollective',
            name: 'MyCollective',
            meta: {
              title: '我的集合版权计划',
            },
            component: () => import(/* webpackChunkName: "mymonitor" */ '../views/CyProtect/MyCollective.vue'),
          },
          {
            path: 'mydciregister',
            name: 'MyDciRegister',
            meta: {
              title: '我的DCI申领',
            },
            component: () => import(/* webpackChunkName: "mymonitor" */ '../views/CyProtect/MyDciRegister.vue'),
          },
          {
            path: 'myspsdraft',
            name: 'MySpsDraft',
            meta: {
              title: '集合版权计划-订单',
            },
            component: () => import(/* webpackChunkName: "myspsdraft" */ '../views/CyProtect/MySpsDraft.vue'),
          },
          {
            path: 'mywebpage',
            name: 'MyWebPage',
            meta: {
              title: '网页取证',
            },
            component: () => import(/* webpackChunkName: "mywebpage" */ '../views/CyProtect/MyWebPage.vue'),
          },
          {
            path: 'myscreen',
            name: 'MyScreen',
            meta: {
              title: '数字公证',
            },
            component: () => import(/* webpackChunkName: "myscreen" */ '../views/CyProtect/MyScreen.vue'),
          },
          {
            path: 'mytrace',
            name: 'MyTrace',
            meta: {
              title: '知识产权溯源',
            },
            component: () => import(/* webpackChunkName: "mytrace" */ '../views/CyProtect/MyTrace.vue'),
          },
          {
            path: 'cyticket',
            name: 'CyTicket',
            meta: {
              title: '版权保护开票申请',
            },
            component: () => import(/* webpackChunkName: "cyticket" */ '../views/Account/CyTicket.vue'),
          },
        ],
      },
      {
        path: '/cytransfer',
        name: 'CyTransfer',
        redirect: '/cytransfer/buycopyright',
        meta: {
          title: '版权转让',
        },
        component: () => import(/* webpackChunkName: "accountlayout" */ '../views/AccountLayout.vue'),
        children: [
          {
            path: '/cytransfer/buycopyright',
            name: 'BuyCopyright',
            meta: {
              title: '我购买的版权',
            },
            component: () => import(/* webpackChunkName: "buycopyright" */ '../views/CyTransfer/BuyCopyright.vue'),
          },
          {
            path: '/cytransfer/salecopyright',
            name: 'SaleCopyright',
            meta: {
              title: '我出售的版权',
            },
            component: () => import(/* webpackChunkName: "salecopyright" */ '../views/CyTransfer/SaleCopyright.vue'),
          },
          {
            path: '/cytransfer/publishcopyright',
            name: 'PublishCopyright',
            meta: {
              title: '发布版权作品',
            },
            component: () => import(/* webpackChunkName: "publishcopyright" */ '../views/CyTransfer/PublishCopyright.vue'),
          },
        ],
      },
      {
        path: '/article/:id',
        name: 'ArticlePage',
        meta: {
          title: '帮助中心',
        },
        component: () => import(/* webpackChunkName: "articlepage" */ '../views/ArticlePage.vue'),
      },
      {
        path: '/page/:id',
        name: 'HtmlPage',
        meta: {
          title: '公告',
        },
        component: () => import(/* webpackChunkName: "HtmlPage" */ '../views/HtmlPage.vue'),
      },
      {
        path: '/search',
        name: 'Search',
        meta: {
          title: '搜索',
        },
        component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue'),
      },
      {
        path: '/certifiy/:id?',
        name: 'Certify',
        meta: {
          title: '作品存证',
        },
        component: () => import(/* webpackChunkName: "certify" */ '../views/Certificate.vue'),
      },
      {
        path: '/certifiy/platform/:id?',
        name: 'CertifyPlatform',
        meta: {
          title: '作品存证',
        },
        component: () => import(/* webpackChunkName: "certify1" */ '../views/Certificate.vue'),
      },
      {
        path: '/certifiy/copyright/deposit/:id?',
        name: 'CertifyDeposit',
        meta: {
          title: '版权存证证书',
        },
        component: () => import(/* webpackChunkName: "certifychain" */ '../views/CertificateChain.vue'),
      },
      {
        path: '/certifiy/copyright/deposit/new/:id?',
        name: 'CertifyDepositNew',
        meta: {
          title: '电子存证证书',
        },
        component: () => import(/* webpackChunkName: "certifye" */ '../views/CertificateE.vue'),
      },
      {
        path: '/certifiy/copyright/register/:id?',
        name: 'CertifyCopyrightRegister',
        meta: {
          title: '版权登记证书',
        },
        component: () => import(/* webpackChunkName: "copyrightcertify" */ '../views/CopyrightRegister.vue'),
      },
      {
        path: '/copyright',
        name: 'CopyRight',
        meta: {
          title: '版权保护',
        },
        component: () => import(/* webpackChunkName: "copyright" */ '../views/CopyRight/Index.vue'),
      },
      {
        path: '/copyright/protection',
        name: 'CopyRightProtection',
        meta: {
          title: '版权保护',
        },
        component: () => import(/* webpackChunkName: "copyright" */ '../views/CopyRight/IndexNew.vue'),
      },
      {
        path: '/copyrightPlan',
        name: 'CopyRightServe',
        meta: {
          title: '版权服务计划',
        },
        component: () => import(/* webpackChunkName: "serve" */ '../views/CopyRight/CopyRightServe.vue'),
      },
      {
        path: '/copyrightDeposit',
        name: 'CopyRightDeposit',
        meta: {
          title: '版权存证',
        },
        component: () => import(/* webpackChunkName: "deposit" */ '../views/CopyRight/CopyRightDeposit.vue'),
      },
      {
        path: '/copyrightCheckin',
        name: 'CopyRightRegister',
        meta: {
          title: '版权登记',
        },
        component: () => import(/* webpackChunkName: "checkin" */ '../views/CopyRight/CopyRightRegister.vue'),
      },
      {
        path: '/copyrightMonitor/:type?',
        name: 'CopyRightMonitor',
        meta: {
          title: '版权监测',
        },
        component: () => import(/* webpackChunkName: "monitor" */ '../views/CopyRight/CopyRightMonitor.vue'),
      },
      {
        path: '/copyrightVerify/:type?',
        name: 'CopyRightVerify',
        meta: {
          title: '取证维权',
        },
        component: () => import(/* webpackChunkName: "verify" */ '../views/CopyRight/CopyrightVerify.vue'),
      },
      {
        path: '/copyright/webEvidence',
        name: 'WebEvidence',
        meta: {
          title: '网页取证',
        },
        component: () => import(/* webpackChunkName: "webevidence" */ '../views/CopyRight/WebEvidence.vue'),
      },
      // {
      //   path: '/recharge',
      //   name: 'Recharge',
      //   meta: {
      //     title: '充值',
      //   },
      //   component: () => import(/* webpackChunkName: "recharge" */ '../views/Recharge.vue'),
      // },
      {
        path: '/signCreator',
        name: 'SignCreator',
        meta: {
          title: '签约创作人',
        },
        component: () => import(/* webpackChunkName: "signcreator" */ '../views/SignCreatorNew.vue'),
      },
      {
        path: '/invite',
        name: 'InviteImg',
        meta: {
          title: '签约创作人',
        },
        component: () => import(/* webpackChunkName: "inviteimg" */ '../views/InviteImg.vue'),
      },
      {
        path: '/invite/company',
        name: 'InviteCompany',
        meta: {
          title: '邀请企业',
        },
        component: () => import(/* webpackChunkName: "invitecompany" */ '../views/InviteCompany.vue'),
      },
      {
        path: '/copyrightJustice/:type?',
        name: 'CopyRightJustice',
        meta: {
          title: '数字公证',
        },
        component: () => import(/* webpackChunkName: "monitor" */ '../views/CopyRight/CopyRightJustice.vue'),
      },
      {
        path: '/copyrightCheckinDci',
        name: 'CopyRightRegisterDci',
        meta: {
          title: '版权登记Dci',
        },
        component: () => import(/* webpackChunkName: "checkin" */ '../views/CopyRight/CopyRightRegisterDci.vue'),
      },
      {
        path: '/cooperation',
        name: 'Cooperation',
        meta: {
          title: '合作申请',
        },
        component: () => import(/* webpackChunkName: "cooperation" */ '../views/Cooperation.vue'),
      },
      {
        path: '/copyright/trace/CreativeProtection',
        name: 'CreativeProtection',
        meta: {
          title: '创意保护',
        },
        component: () => import(/* webpackChunkName: "creativeorotection" */ '../views/CopyrightTrace/CreativeProtection.vue'),
      },
      {
        path: '/copyright/trace/FlowProtection',
        name: 'FlowProtection',
        meta: {
          title: '流转保护',
        },
        component: () => import(/* webpackChunkName: "flowprotection" */ '../views/CopyrightTrace/FlowProtection.vue'),
      },
      {
        path: '/copyright/trace/SolidEvidence',
        name: 'SolidEvidence',
        meta: {
          title: '证据固证',
        },
        component: () => import(/* webpackChunkName: "SolidEvidence" */ '../views/CopyrightTrace/SolidEvidence.vue'),
      },
      {
        path: '/copyright/trace/cert',
        name: 'CopyrightTraceDetail',
        meta: {
          title: '作品溯源详情',
        },
        component: () => import(/* webpackChunkName: "certificatetracechain" */ '../views/CertificateTraceChain.vue'),
      },
    ],
  },

  {
    path: '/activity/:id',
    name: 'Activity',
    component: () => import(/* webpackChunkName: "activity"*/ '../views/Activity.vue'),
  },
  {
    path: '/forum2022',
    name: 'Forum',
    component: () => import(/* webpackChunkName: "forum"*/ '../views/Forum2022.vue'),
  },
  {
    path: '/forum2023',
    name: 'Forum3',
    component: () => import(/* webpackChunkName: "forum3"*/ '../views/Forum2023.vue'),
  },
  {
    path: '/copyright0426',
    name: 'Copyright0426',
    component: () => import(/* webpackChunkName: "forum"*/ '../views/Copyright0426.vue'),
  },
  {
    path: '/gift',
    name: 'GiftCard',
    component: () => import(/* webpackChunkName: "gift"*/ '../views/GiftCard.vue'),
  },
  {
    path: '/tool',
    name: 'ToolPage',
    component: () => import(/* webpackChunkName: "toolpage" */ '../views/ToolPage.vue'),
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "notfound" */ '../views/NotFound.vue'),
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/404',
  },
];
const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes: [...routes],
});

/**
 * 判断是否登录
 */
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  document.title = (to.meta.title || '') + ' 版权保护_正版视频图片_版权管理_版权确权_版权登记_监测维权_版权代理 ';
  next();
});
const NoAutoPv = ['VideoDetail'];
const NoH5 = [
  'Forum',
  'Forum3',
  'Copyright0426',
  'CertifyDeposit',
  'CertifyCopyrightRegister',
  'GiftCard',
  'CertifyDepositNew',
  'Cooperation',
  'SignCreator',
  'InviteImg',
  'InviteCompany',
  'ArticlePage',
];
router.afterEach(($route) => {
  window.scrollTo(0, 0);
  try {
    if (!NoAutoPv.includes($route.name)) {
      pv();
    }
    if (/Mobi|Android|iPhone/i.test(navigator.userAgent) && !NoH5.includes($route.name)) {
      // 当前设备是移动设备
      // 对应页面映射
      const isProduction = process.env.NODE_ENV === 'production';
      const _defaultMobileUrl = $route.query?.inviteId ? `https://m.vlian.cn/?inviteId=${$route.query?.inviteId}` : 'https://m.vlian.cn/';
      const CR_M_HOST = isProduction ? 'https://copyright-h5.vlian.cn' : 'http://copyright-h5.dev1.vlian.cn';
      const CR_M_MAIN = isProduction ? 'https://m.vlian.cn' : 'http://demoh5.dev1.vlian.cn';
      const _routerMap = {
        AblumList: `${CR_M_MAIN}/pages/AblumList/index?type=${$route.params.type || ''}`,
        AblumListDetail: `${CR_M_MAIN}/pages/AblumListDetail/index?id=${$route.params.id || ''}`,
        VideoDetail: `${CR_M_MAIN}/pages/VideoDetail/index?id=${$route.params.id || ''}`,
        Search: `${CR_M_MAIN}/pages/Search/index?categoryId=${$route.query.categoryId || ''}`,
        Cart: `${CR_M_MAIN}/pages/User/cart`,
        MyCollect: `${CR_M_MAIN}/pages/User/collect`,
        OrderList: `${CR_M_MAIN}/pages/User/order`,
        CopyRight: `${CR_M_HOST}`,
        CopyRightDeposit: `${CR_M_HOST}/pages/copyright/CopyRightDeposit`,
        CopyRightServe: `${CR_M_HOST}/pages/copyright/CopyRightServe`,
        CopyRightRegister: `${CR_M_HOST}/pages/copyright/CopyRightRegister`,
        CopyRightMonitor: `${CR_M_HOST}/pages/copyright/CopyRightMonitor`,
        CopyRightJustice: `${CR_M_HOST}/pages/copyright/CopyRightJustice`,
        PopularInvited: `${CR_M_MAIN}/pages/User/invited`,
        CreativeProtection: `${CR_M_HOST}/pages/copyright/trace/CreateProtect`,
        FlowProtection: `${CR_M_HOST}/pages/copyright/trace/TurnoverProtect`,
        SolidEvidence: `${CR_M_HOST}/pages/copyright/trace/SolidEvidence`,
      };
      window.location.href = _routerMap[$route?.name] || _defaultMobileUrl;
    }
  } catch (error) {
    console.log(error);
  }
});
export default router;
